const SSO_URL = import.meta.env.VITE_SSO_URL;
const APP_URL = import.meta.env.VITE_APP_URL;
const TDWEBSITE_BASE = import.meta.env.VITE_TDWEBSITE_BASE;

export const navigateToTab = (url, target = '_blank') => {
  window.open(url, target).focus();
};

export const navigateToURL = (url) => {
  window.location.href = url;
};

export const navigateToSSO = () => {
  const currentPath = window.location.pathname;
  const encodedPath = encodeURIComponent(currentPath);
  const SSO_REDIRECT_URL = `${SSO_URL}/?next=${APP_URL}${encodedPath}&hideref=true`;

  window.location.href = SSO_REDIRECT_URL
};

export const navigateToURLorOnboarding = (url,flag=false) => {
  if(flag){
    window.location.href = url;
  } else {
    window.location.href = `${TDWEBSITE_BASE}?ctx=onboard`;
  }
};

export const getNavigationUrl = (url,flag=false) => {
  if(flag)
    return url;
    
  return `${TDWEBSITE_BASE}?ctx=onboard`;
}